module.exports = __webpack_public_path__ + "img/team-2.a105ddd8.jpg";